import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Cpu, Globe } from 'lucide-react';

const ProfileFooter = () => {
  return (
    <motion.footer 
      className="relative z-10 bg-gradient-to-r from-[#0A0E1B]/95 via-[#0D1220]/90 to-[#0A0E1B]/95 border-t border-white/[0.05] backdrop-blur-xl"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1 }}
    >
      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-6 text-sm text-[#8AA5A2]">
            <span>Powered by</span>
            <div className="flex items-center gap-4">
              <motion.a
                href="https://amportal.ai"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-[#15FF75] transition-colors"
                whileHover={{ scale: 1.05 }}
              >
                <Shield className="w-4 h-4" />
                <span className="font-medium">amPortal</span>
              </motion.a>
              
              <motion.a
                href="https://ao.arweave.net"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-[#00D4FF] transition-colors"
                whileHover={{ scale: 1.05 }}
              >
                <Cpu className="w-4 h-4" />
                <span className="font-medium">aoTheComputer</span>
              </motion.a>
              
              <motion.a
                href="https://ar.io"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-[#FFB800] transition-colors"
                whileHover={{ scale: 1.05 }}
              >
                <Globe className="w-4 h-4" />
                <span className="font-medium">ARIO Network</span>
              </motion.a>
            </div>
          </div>
          
          <div className="flex items-center gap-4">
            <div className="w-2 h-2 bg-[#15FF75] rounded-full" />
            <span className="text-sm text-[#15FF75] font-medium">Connected to Permaweb</span>
          </div>
        </div>
      </div>
    </motion.footer>
  );
};
export default ProfileFooter;